import { apiClient } from "../config";

export interface StudentRating {
  id: number;
  student: {
    id: number;
    firstName: string;
    middleName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    country: string;
    countryState: string;
    isActive: number;
    lgc: string | null;
    dateOfBirth: string | null;
    timeCreated: string;
    staff: null;
    uid: string | null;
    modifiedProfile: boolean;
    modifiedLgc: boolean;
    modifiedDob: boolean;
  };
  totalPassedPaidCourses: number;
  monthsActive: number;
  rating: number;
  avgPerMonth: number;
  weightedAvgPerMonth: number;
  startDate: string;
  endDate: string;
  computedDate: string;
}

export interface StudentRatingsResponse {
  content: StudentRating[];
  pageable: {
    sort: {
      sorted: boolean;
      unsorted: boolean;
      empty: boolean;
    };
    pageNumber: number;
    pageSize: number;
    offset: number;
    paged: boolean;
    unpaged: boolean;
  };
  last: boolean;
  totalPages: number;
  totalElements: number;
  first: boolean;
  sort: {
    sorted: boolean;
    unsorted: boolean;
    empty: boolean;
  };
  number: number;
  numberOfElements: number;
  size: number;
  empty: boolean;
}

export const getStudentRatings = async (
  page = 0,
  size = 20,
  search?: string
): Promise<StudentRatingsResponse> => {
  const params: any = { page, size };

  if (search) {
    params.search = search;
  }

  const { data } = await apiClient.get("/public/getStudentRatings", { params });
  return data;
};
